import { render } from "./LwSwitch.vue?vue&type=template&id=296c2b85&scoped=true"
import script from "./LwSwitch.vue?vue&type=script&lang=js"
export * from "./LwSwitch.vue?vue&type=script&lang=js"

import "./LwSwitch.vue?vue&type=style&index=0&id=296c2b85&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c2b85"]])

export default __exports__